import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const analyticsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "analytics",
}).lazy(() => import("./Analytics.lazy").then((d) => d.Route));
